import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Heart: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.error.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.1348 3.78538C20.5655 3.21229 19.9101 2.77146 19.1685 2.46288C18.427 2.15429 17.6442 2 16.8202 2C16.0112 2 15.2172 2.15429 14.4382 2.46288C13.6592 2.77146 12.985 3.21229 12.4157 3.78538L12.0337 4.16009L11.6517 3.78538C11.0824 3.21229 10.4195 2.77146 9.66292 2.46288C8.90636 2.15429 8.10113 2 7.24719 2C6.42322 2 5.64045 2.15429 4.89888 2.46288C4.1573 2.77146 3.50188 3.21229 2.93258 3.78538C2.34831 4.34378 1.88015 5.00502 1.52809 5.76914C1.17603 6.53326 1 7.31206 1 8.10557C1 8.89908 1.16105 9.67788 1.48315 10.442C1.80525 11.2061 2.25093 11.8674 2.82022 12.4258L11.2697 20.7135C11.3596 20.8016 11.4569 20.8714 11.5618 20.9229C11.6667 20.9743 11.794 21 11.9438 21C12.0787 21 12.1985 20.9743 12.3034 20.9229C12.4082 20.8714 12.5131 20.8016 12.618 20.7135L21.0449 12.4258C21.6891 11.838 22.176 11.1694 22.5056 10.42C22.8352 9.67053 23 8.89908 23 8.10557C23 7.31206 22.8502 6.54061 22.5506 5.79118C22.236 5.04176 21.764 4.37317 21.1348 3.78538Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default Heart;
